// extracted by mini-css-extract-plugin
module.exports = {"offline":"style_offline__mkiec"};